import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IconColor, IconNames, IconSize, IconType, S_CODE_ICONS, SCode } from '../../common';
import { Tracking } from '../../store/models';
import { StatusAcceptanceType } from '../../store/constants';

@Component({
  selector: 'ui-horizontal-status-tracking',
  templateUrl: './horizontal-status-tracking.component.html',
  styleUrls: ['./horizontal-status-tracking.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HorizontalStatusTrackingComponent {
  @Input() statuses: Tracking[];
  // TODO remove after DN/HU implementation
  @Input() isTimezoneAvailable = true;

  iconType = IconType;
  iconSize = IconSize;
  iconColor = IconColor;
  sCodeIcons: Map<SCode, IconNames> = S_CODE_ICONS;
  browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  dateFormat: string;
  acceptanceType = StatusAcceptanceType;
}
